import { render, staticRenderFns } from "./EducationalRatingsComponent.vue?vue&type=template&id=6f8e8baf&"
import script from "./EducationalRatingsComponent.vue?vue&type=script&lang=js&"
export * from "./EducationalRatingsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports